<template>
  <div class="locale-changer place-right">
     <a href="#" class="dropdown-toggle app-bar-item" id="dropdown_toggle_1" data-effect="fade" :title="$t('Lang')">
        <span class="icon">
            <country-flag :country="locale === 'en' ? 'gb' : locale === 'el' ? 'gr' : locale" size="small" class="d-inline-block va-middle"/>
        </span>   
      </a>
      <ul
        id="langdropdown"
        class="d-menu border bg-white mt-1 place-right compact"
        data-role="dropdown"
        data-toggle-element="#dropdown_toggle_1">
        <li
          v-for="(lang, i) in languages"
          :key="`Lang${i}`"
          :class="['text-small', { active: lang.language === $i18n.locale }]"
          :value="lang.language"
          @click="$i18n.locale = lang.language">
          <a href="#" class="d-flex flex-align-center">
            <span >
              <country-flag :country="lang.flag" size="small" mode='squared' class="d-inline-block va-middle"/>
            </span>
            <span class="va-middle">{{ lang.title }}</span>
          </a>
        </li>
      </ul>

  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  watch: {
      '$i18n.locale': {
          handler: function (locale) {
            this.locale = locale;
            document.documentElement.lang = this.locale;
            this.$moment.locale(this.locale);
            window.METRO_LOCALE = this.locale;
            $.meta('metro4:locale').attr("content",this.locale);
            localStorage.setItem('lang', this.locale);
          },
          deep: true,
          immediate: true
      }
  },
  created: function() {
      this.locale = localStorage.getItem('lang') ?? $i18n.locale ?? "en";
      document.documentElement.lang =this.locale;
      this.$moment.locale(this.locale);
      window.METRO_LOCALE = this.locale;
      $.meta('metro4:locale').attr("content",this.locale);
      localStorage.setItem('lang', this.locale);
  },
  data () {
    return { 
      locale:'en',
      languages: [
            { flag: 'gb', language: 'en', title: 'English' },
            { flag: 'it', language: 'it', title: 'Italiano' },
            { flag: 'fr', language: 'fr', title: 'Français' },
            { flag: 'pt', language: 'pt', title: 'Português'},
            { flag: 'es', language: 'es', title: 'Español'  },
            { flag: 'de', language: 'de', title: 'Deutsch'  }, 
            { flag: 'gr', language: 'el', title: 'Ελληνικά' },
            { flag: 'pl', language: 'pl', title: 'Polski'   },
        ], }
  }
}
</script>
